module.exports = __webpack_public_path__ + "static/mtb-9-74f7f6190a42ca4517a3bde50b184c05.jpg";